"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiMenuItem = void 0;
exports.MuiMenuItem = {
    styleOverrides: {
        root: {
            fontSize: 14,
            '& .MuiListItemText-root': {
                paddingLeft: 8,
            },
        },
    },
};
//# sourceMappingURL=MuiMenuItem.js.map